import { gaEvent } from "../utils/gaAnalytics";
import { trackEvent } from "./mixpanel";

/**
 * Events that must reach both GA4 and Mixpanel with identical names and
 * properties. One call per site keeps the two from drifting apart.
 * Names are shared with the Android/iOS/Windows apps — do not rename.
 */
const trackBoth = (eventName, params = {}, options) => {
  gaEvent(eventName, params);
  trackEvent(eventName, params, options);
};

/** A click on any "download the app" CTA. `location` names the CTA. */
export const trackDownloadClick = ({ platform, location, file_name } = {}) =>
  trackBoth(
    "download_click",
    { platform, location, ...(file_name ? { file_name } : {}) },
    // Most CTAs open a store URL or start a file download immediately.
    { beforeNavigation: true }
  );

/** The installer file finished downloading in-page. */
export const trackFileDownload = (params = {}) => trackBoth("file_download", params);

/** The in-page installer download failed. */
export const trackFileDownloadFailed = (params = {}) =>
  trackBoth("file_download_failed", params);
